import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id", "aria-controls"]
const _hoisted_2 = ["tabindex", "role", "aria-checked"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "el-checkbox__inner" }, null, -1)
const _hoisted_4 = ["checked", "aria-hidden", "name", "disabled", "true-value", "false-value"]
const _hoisted_5 = ["aria-hidden", "disabled", "value", "name"]
const _hoisted_6 = {
  key: 0,
  class: "el-checkbox__label body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    id: _ctx.id,
    class: _normalizeClass(["el-checkbox", [
      _ctx.border && _ctx.checkboxSize ? 'el-checkbox--' + _ctx.checkboxSize : '',
      { 'is-disabled': _ctx.isDisabled },
      { 'is-bordered': _ctx.border },
      { 'is-checked': _ctx.isChecked }
    ]]),
    "aria-controls": _ctx.indeterminate ? _ctx.controls : null
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["el-checkbox__input", {
        'is-disabled': _ctx.isDisabled,
        'is-checked': _ctx.isChecked,
        'is-indeterminate': _ctx.indeterminate,
        'is-focus': _ctx.focus
      }]),
      tabindex: _ctx.indeterminate ? 0 : false,
      role: _ctx.indeterminate ? 'checkbox' : false,
      "aria-checked": _ctx.indeterminate ? 'mixed' : false
    }, [
      _hoisted_3,
      (_ctx.trueLabel || _ctx.falseLabel)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
            checked: _ctx.isChecked,
            class: "el-checkbox__original",
            type: "checkbox",
            "aria-hidden": _ctx.indeterminate ? 'true' : 'false',
            name: _ctx.name,
            disabled: _ctx.isDisabled,
            "true-value": _ctx.trueLabel,
            "false-value": _ctx.falseLabel,
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args))),
            onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.focus = true)),
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.focus = false))
          }, null, 40, _hoisted_4)), [
            [_vModelCheckbox, _ctx.model]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model) = $event)),
            class: "el-checkbox__original",
            type: "checkbox",
            "aria-hidden": _ctx.indeterminate ? 'true' : 'false',
            disabled: _ctx.isDisabled,
            value: _ctx.label,
            name: _ctx.name,
            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args))),
            onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.focus = true)),
            onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.focus = false))
          }, null, 40, _hoisted_5)), [
            [_vModelCheckbox, _ctx.model]
          ])
    ], 10, _hoisted_2),
    (_ctx.$slots.default || _ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
          _renderSlot(_ctx.$slots, "default"),
          (!_ctx.$slots.default)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.label), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}